import React, { useState} from 'react';

import Indicator from './Indicator';

const IndicatorGroup = (props) => {
    let { 
        imageURL, 
        groupNumber, 
        title, 
        indicators, 
        onOpenURL, 
        detailColor, 
    } = props;
    const [open, setOpen] = useState(false);
    return (
        <div className="IndicatorGroup">
            <header className="GroupHeader" onClick={() => setOpen(!open)}>
                <img className="Image" src={imageURL} alt={`Group #${groupNumber}`} />
                <div className="TitleContainer">
                    <span className="Title">{title}</span>
                </div>
            </header>
            {open && 
                <div className="IndicatorsContainer">
                    {(indicators || []).map((indicator, index) =>
                        <Indicator
                            key={`Indicator-${index}`}
                            onOpenURL={onOpenURL}
                            detailColor={detailColor}
                            {...indicator}
                        />
                    )}
                </div>
            }
        </div>
    );
}

export default IndicatorGroup;